import React from 'react';
import { TwoFAInfo } from './2FAInfo';

export default {
  messageId: 'two-fa-enablement-admin',
  bannerTag: 'ACCOUNT_SEC_WARNING',
  descriptionComponent: (props) => (
    <TwoFAInfo
      {...props}
      linkTranslationId={{
        base: 'ACCOUNT_SEC_LINK_DESCRIPTION_ADMIN_NEW',
        extension: 'ACCOUNT_SEC_LINK_DESCRIPTION_ADMIN',
      }}
      descriptionTranslationId={'ACCOUNT_SEC_DESCRIPTION_ADMIN_NEW'}
      linkHref={'/admin/org-settings/sso'}
      openInTheNewTab={true}
    />
  ),
  type: 'account',
  additionalAttributes: [
    {
      name: 'endDate',
      requireTranslate: false,
    },
    {
      name: 'isExtension',
      requireTranslate: false,
    },
  ],
};
